// Populator validations
// https://github.com/IFTTT/ifttt_front_end/blob/master/app/models/concerns/ifttt/has_populator.rb
export function validatePopulator(populator = [], errors = [], fieldType = "") {
  if (fieldType === "collection_select" && populator.length < 2) {
    errors.push("Populator requires at least two options")
  } else if (fieldType === "checkbox_multi" && populator.length < 1) {
    errors.push("Populator requires an option")
  }

  if (populator.filter(o => !(o.label && o.value)).length > 0) {
    errors.push("Options need to have both a label and value")
  }

  const labelSet = new Set()
  const valueSet = new Set()
  populator.forEach(o => {
    labelSet.add(o.label)
    valueSet.add(o.value)
  })
  if (labelSet.size != populator.length) {
    errors.push("Names need to be unique")
  }

  // The `defaultValueJson` graph field only returns the value of the option
  // instead of both the label and value. With dropdowns and checkboxes,
  // we do not know which label to use. To make things easier for now
  // we will enforce a uniqueness on both label and value even though
  // IFE only enforces unique names right now.
  if (valueSet.size != populator.length) {
    errors.push("Values need to be unique")
  }

  return errors
}
